angular.module("avant.customer_applications.directives").directive "amountHideInputWrappers", ->
  restrict: "A"
  link: (scope, element, attrs) ->
    return unless attrs.amountHideInputWrappers
    hideWrapperConfig = JSON.parse(attrs.amountHideInputWrappers)

    scope.$watch (-> element.attr("class")), ->
      rawDomElement = element[0]
      rawDomParentElement = rawDomElement.parentElement

      if hideWrapperConfig.wrapper_class
        toggleWrapperVisbility(rawDomParentElement, isElementHidden(rawDomElement))
      if hideWrapperConfig.section_class
        toggleSectionVisibility(rawDomParentElement)

    # Traverse element's parents until either:
    #   1) The current element has a class that is equivalent to the value of
    #      hideWrapperConfig.wrapper_class, and add/remove 'ng-hide' to/from
    #      the current element based on the value of 'ng-hide' on the directive's element
    #   2) The last interation had no parent, or the current element has an ID of
    #      'maincontent', which means that the element was not found
    toggleWrapperVisbility = (el, hide) ->
      if traversedTooFar(el) then return

      if el.classList.contains(hideWrapperConfig.wrapper_class)
        toggleVisibility(el, hide)
      else
        toggleWrapperVisbility(el.parentElement, hide)

    # Traverse element's parents until either:
    #   1) The current element has a class that is equivalent to the value of
    #      hideWrapperConfig.section_class. Add/remove 'ng-hide' to/from
    #      the current element if all of the children of the current element, with
    #      a class matching the value of hideWrapperConfig.wrapper_class are all hidden.
    #   2) The last interation had no parent, or the current element has an ID of
    #      'maincontent', which means that the element was not found
    toggleSectionVisibility = (el) ->
      if traversedTooFar(el) then return

      if el.classList.contains(hideWrapperConfig.section_class)
        toggleVisibility(el, allChildrenWrappersHidden(el.children))
      else
        toggleSectionVisibility(el.parentElement)

    # Deep traversal of children elements that have a class that matches the value
    # of hideWrapperConfig.wrapper_class, and return true if all matching elements
    # are hidden
    allChildrenWrappersHidden = (children) ->
      if children.length == 0 then return true

      _.every children, (child) ->
        if child.classList.contains(hideWrapperConfig.wrapper_class)
          if isElementHidden(child) then return true else return false
        else
          true && allChildrenWrappersHidden(child.children)

    toggleVisibility = (el, hide) ->
      if hide then el.classList.add("ng-hide") else el.classList.remove("ng-hide")

    traversedTooFar = (el) ->
      !el || el.getAttribute("id") == "maincontent"

    isElementHidden = (el) ->
      el.classList.contains("ng-hide")
